import { render, staticRenderFns } from "./RequestDetailFormNew.vue?vue&type=template&id=391abf8c&scoped=true"
import script from "./RequestDetailFormNew.vue?vue&type=script&lang=ts"
export * from "./RequestDetailFormNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailFormNew.vue?vue&type=style&index=0&id=391abf8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391abf8c",
  null
  
)

export default component.exports